import moment from "moment/moment";

const state = {
  range: [
    moment().subtract(1, 'month').subtract(1, 'day').format(),
    moment().subtract(1, 'day').format(),
  ],
  compare: false,
  compareRange: [
    undefined,
    undefined,
  ],
};

const getters = {
  range: ({range}) => range,
  fromDate: ({range}) => range[0] || undefined,
  toDate: ({range}) => range[1] || undefined,
  compare: ({compare}) => compare,
  compareRange: ({compareRange}) => compareRange,
  compareFromDate: ({compareRange}) => compareRange[0] || undefined,
  compareToDate: ({compareRange}) => compareRange[1] || undefined,
};

const mutations = {
  setRange: (state, newRange) => state.range = newRange,
  setCompare: (state, newCompare) => state.compare = newCompare,
  setCompareRange: (state, newCompareRange) => state.compareRange = newCompareRange,
};

const actions = {
  setFilter: ({commit}, {range, compare, compareRange}) => {
    commit('setRange', range);
    commit('setCompare', compare);
    commit('setCompareRange', compareRange);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};